import toDateOnlyDisplay from "../../utilities/toDateOnlyDisplay"

const LableValueDisplay = ({name, value, imputtype}) => {
  if(imputtype=="date") value = toDateOnlyDisplay(value);
  return (    
    <>
    {/* <span className="title fw-medium w-40 d-inline-block"> {name} :</span>   */}
    {/* <span className="title fw-medium d-inline-block" style={{paddingRight:"10px"}}> {name} :</span>  
    {value && <span className="text">{value}</span>} */}

    <div>                    
      <strong style={{paddingRight:"10px"}}>{name}:</strong>{value??""}
    </div>

    </>
  )
}

export default LableValueDisplay